import {memo, useEffect, useState} from "react";
import {SectionHeader} from "./Layouts/SectionHeader";
import useWindowSize from "Hooks/useWindowSize";
import {useUserBankCardsQuery} from "Hooks/Queries/User/useUserBankCardsQuery";

export interface IBank {
  id: string;
  name: string;
  label: string;
  img: string;
}

export const BANKS: IBank[] = [
  {
    id: "bog",
    name: "საქართველოს ბანკი",
    label: "Visa / mastercard / amex",
    img: "/images/icons/bank/bog.svg",
  },
  {
    id: "tbc",
    name: "თიბისი ბანკი",
    label: "Visa / mastercard",
    img: "/images/icons/bank/tbc.svg",
  },
]

export const BankCards = memo(function BankCardsComponent({
                                                            setPaymentMethod,
                                                            paymentRef,
                                                            paymentMethod,
                                                            fromProfile = false,
                                                            hideHeader = false,
                                                          }: {
  setPaymentMethod?: any;
  paymentRef?: any;
  paymentMethod?: any;
  fromProfile?: boolean;
  hideHeader?: boolean;
}) {
  const {bankCard, isLoadingBankCard, isErrorBankCard, isSuccessBankCard} =
      useUserBankCardsQuery();
  const {width} = useWindowSize();

  // const [savedcards] = useState([
  //   {
  //     id: 0,
  //     pan: "1230102392",
  //   },
  // ]);

  useEffect(() => {
    if (bankCard?.savedCards && fromProfile == true) {
      setPaymentMethod({
        method: "savedcard",
        card: bankCard?.subscriptionCard?.id,
        pan: bankCard?.subscriptionCard?.pan,
      });
    }
  }, [bankCard]);


  return (
      <div ref={paymentRef}>
        {width > 832 && !fromProfile && !hideHeader && (
            <SectionHeader title="გადახდის მეთოდები"/>
        )}
        <h2 className="text-[18px] font-bold mb-4 text-[#000]">გადახდა ბარათით</h2>
        <div
            className={`${
                !fromProfile && ""
            } flex flex-col md:gap-y-5 gap-y-10 rounded-[12px] md:p-0`}
        >
          {bankCard?.savedCards?.length > 0 && (
              <div>
                <h2 className="text-base font-bold mb-3 text-lightgray">მონიშნე შენახული ბარათი</h2>
                <div className="bg-gray-30 px-8 md:px-4 rounded-[12px] flex flex-col">
                  {bankCard?.subscriptionCard && (
                      <div
                          onClick={() =>
                              setPaymentMethod({
                                method: "savedcard",
                                card: bankCard?.subscriptionCard?.id,
                                pan: bankCard?.subscriptionCard?.pan,
                              })
                          }
                          className={
                            bankCard?.savedCards?.filter(
                                (e: any) => e.id !== bankCard?.subscriptionCard?.id
                            ).length == 0
                                ? `cursor-pointer  py-6 md:py-4 flex justify-between items-center ${bankCard?.savedCards.filter((e: any) => e.id !== bankCard?.subscriptionCard?.id).length > 1 ? "border-b-[1px] border-solid border-b-[#E8ECF4]" : ""} `
                                : "cursor-pointer py-6 md:py-4 flex justify-between items-center border-b-[1px] border-solid border-b-[#E8ECF4] last:border-b-[0px]"
                          }
                      >
                        <div className="flex items-center gap-3">
                          <div
                              className="w-[32px] h-[24px] rounded-[5px] border-[1px] border-solid border-[#E8ECF4] flex items-center justify-center">
                            <img
                                className="max-w-[24px]"
                                src={
                                  bankCard?.subscriptionCard?.pan?.substring(0, 1) ==
                                  "5"
                                      ? "/images/icons/mastercard.svg"
                                      : "/images/icons/visacard.svg"
                                }
                            />
                          </div>
                          <div className="flex flex-col">
                            <span className="font-demi text-rg text-blackPrimary-100">
                              {bankCard?.subscriptionCard?.pan?.substring(0, 1) == "5"
                                  ? "MASTERCARD"
                                  : "VISA"}
                            </span>
                            <span className="text-[12px] font-regular text-blackPrimary-100">
                              {bankCard?.subscriptionCard?.pan}
                            </span>
                          </div>
                        </div>
                        {paymentMethod?.card == bankCard?.subscriptionCard?.id ? (
                            <button
                                className="w-[20px] h-[20px] bg-[#fff] border-[6px] border-solid border-green-100 rounded-[50%]"/>
                        ) : (
                            <button
                                className="w-[20px] h-[20px] bg-blackPrimary-10 border-[#070A1433] border-[1px] rounded-[50%]"/>
                        )}
                      </div>
                  )}

                  {/*{bankCard?.savedCards.map(*/}
                  {bankCard?.savedCards.map(
                      (item: any, i: number) =>
                          bankCard?.subscriptionCard?.id !== item?.id && (
                              <div
                                  key={i}
                                  onClick={() =>
                                      setPaymentMethod({
                                        method: "savedcard",
                                        card: item.id,
                                        pan: item.pan,
                                        // sourceId: item.sourceId
                                      })
                                  }
                                  className={
                                    i ==
                                    bankCard?.savedCards?.filter(
                                        (e: any) => e.id !== bankCard?.subscriptionCard?.id
                                    ).length -
                                    1
                                        ? "cursor-pointer flex py-6 md:py-4 justify-between items-center border-b-[1px] border-solid border-b-[#E8ECF4] last:border-b-[0px]"
                                        : "cursor-pointer flex py-6 md:py-4 justify-between items-center border-b-[1px] border-solid border-b-[#E8ECF4] last:border-b-[0px]"
                                  }
                              >
                                <div className="flex items-center gap-3">
                                  <div
                                      className="w-[32px] h-[24px] rounded-[5px] border-[1px] border-solid border-[#E8ECF4] flex items-center justify-center">
                                    <img
                                        className="max-w-[24px]"
                                        src={
                                          item.pan.substring(0, 1) == "5"
                                              ? "/images/icons/mastercard.svg"
                                              : "/images/icons/visacard.svg"
                                        }
                                    />
                                  </div>
                                  <div className="flex flex-col">
                                    <span className="font-demi text-rg text-blackPrimary-100">
                                      {item.pan.substring(0, 1) == "5"
                                          ? "MASTERCARD"
                                          : "VISA"}
                                    </span>
                                    <span className="text-[12px] font-regular text-blackPrimary-100">
                                      {item.pan}
                                    </span>
                                  </div>
                                </div>
                                {paymentMethod?.card == item.id ? (
                                    <button
                                        className="w-[20px] h-[20px] bg-[#fff] border-[6px] border-solid border-green-100 rounded-[50%]"/>
                                ) : (
                                    <button
                                        className="w-[20px] h-[20px] bg-blackPrimary-10 border-[#070A1433] border-[1px] rounded-[50%]"/>
                                )}
                              </div>
                          )
                  )}
                </div>
              </div>
          )}

          <div>
            <h2 className="font-bold mb-3 text-lightgray text-base">ახალი ბარათის დამატება</h2>
            <div
                className={`grid ${fromProfile ? "grid-cols-1 md:gap-y-4 gap-y-4" : "md:grid-cols-1 grid-cols-2 "} gap-x-8 md:gap-y-4 gap-y-0`}>

              {BANKS?.map((bank) => {
                return <div
                    onClick={() =>
                        setPaymentMethod({
                          method: bank.id,
                          card: "bank",
                        })
                    }
                    className={"cursor-pointer p-5 rounded-xl bg-gray-30 flex justify-between items-center"}
                >
                  <div className="flex items-center">
                    <div className={"bg-[#FFF] flex items-center justify-center w-10 h-10 rounded-xl mr-2"}>
                      <img
                          alt={bank?.img + " logo"}
                          className="max-w-[24px] w-6 h-6 min-h-6 min-w-6"
                          src={bank?.img}
                      />
                    </div>

                    <div className={""}>
                      <span className="text-sm font-bold text-blackPrimary-100">
                        {bank?.name?.toUpperCase()}
                      </span>
                      <p className="text-[12px] text-lightgray font-demi uppercase">
                        {bank?.label}
                      </p>
                    </div>

                  </div>
                  {paymentMethod?.method == bank?.id ? (
                      <button
                          className="w-[20px] h-[20px] bg-[#fff] border-[6px] border-solid border-green-100 rounded-[50%]"/>
                  ) : (
                      <button
                          className="w-[20px] h-[20px] bg-blackPrimary-10 border-[#070A1433] border-[1px] rounded-[50%]"/>
                  )}
                </div>
              })}

            </div>
          </div>
        </div>
      </div>
  );
});
